export function compareDate(one?: Date, other?: Date): number {
  const oneTimestamp = one ? one.getTime() : Infinity;
  const otherTimestamp = other ? other.getTime() : Infinity;

  return oneTimestamp - otherTimestamp;
}
